The maximum amount an organization is willing to pay for a position.

When provided, the value must be greater than or equal to the value of `minimumAmount` and the currency must match `minimumAmount`.

This should be a mandatory input in your software and will be required in our schema in future.
Currently, omitting the field will default it to `minimumAmount` and harm the performance of the job ad.
